export default __webpack_public_path__ + "static/media/o3.875062a3.jpg";